import { type HeapEventsType } from './heapEvents'

export function trackHeapEvent(eventId: HeapEventsType, data?: object) {
  window.heap.track(eventId, data)
}
